import axios from "axios";
import jsPDF from "jspdf";
import moment from "moment";
import db from "./db";

export async function GeneratePdf(i18n, settings, filterDate, school, username, name, totalAbsence, showPresence?, PDF_Title?, PDF_Subject?, PDF_Author?, PDF_Creator?) {

  let registrations: any = await db.GetReportData_LUDUS(username, filterDate.from, filterDate.to);
  let image = ""
  let imageFormat = 'JPEG'
  try {
    await axios.get(`${settings.USER_IMAGE_URL}/${username}.jpg${settings.IMAGE_SAS_TOKEN}`, {
      headers: { "Access-Control-Allow-Origin": "*" },
      responseType: 'arraybuffer'
    }).then(response => {
      image = Buffer.from(response.data, 'binary').toString('base64')
    })
  } catch (error) {
    await axios.get(`/images/person.png`, {
      headers: { "Access-Control-Allow-Origin": "*" },
      responseType: 'arraybuffer'
    }).then(response => {
      image = Buffer.from(response.data, 'binary').toString('base64')
      imageFormat = 'PNG'
    })
  }


  const doc = new jsPDF({
    orientation: 'p',
    unit: 'pt',
    format: 'a4',
    putOnlyUsedFonts: true
  });
  doc.setProperties({
    title: PDF_Title,
    subject: PDF_Subject,
    author: PDF_Author,
    keywords: "",
    creator: PDF_Creator
  })

  const imgProps = doc.getImageProperties(image);

  let height = 190;
  let width = 190;

  if (imgProps.height > imgProps.width) {
    height = imgProps.height / imgProps.width * 190
    let y = 45;
    if (height > 190) {
      //y = y - Math.abs((height - 190) / 2)
    }


    doc.addImage(image, imageFormat, 35, y, width, height);

    doc.setFillColor(255, 255, 255);
    doc.setDrawColor('#FFFFFF')
    doc.rect(30, 0, 200, 45, 'F');
    doc.rect(30, 235, 200, 200, 'F');
  }
  else {
    width = imgProps.width / imgProps.height * 190
    let x = 35;
    if (width > 190) {
      x = x - Math.abs((width - 190) / 2)
    }


    doc.addImage(image, imageFormat, x, 45, width, height);

    doc.setFillColor(255, 255, 255);
    doc.setDrawColor('#FFFFFF')
    doc.rect(0, 40, 35, 200, 'F');
    doc.rect(225, 40, 500, 200, 'F');
  }



  doc.setTextColor("#000000")
  doc.setFontSize(10);
  doc.text(name ? name : "", 35, 30);
  doc.text(i18n.t('caseworker-pdfexport-text1') + " " + moment().format("DD-MM-YYYY"), 560, 30, { align: 'right' });

  doc.setLineWidth(1);

  doc.setDrawColor('#C5C5C5')
  doc.setFillColor(246, 246, 246);

  doc.rect(35, 45, 190, 190);
  doc.rect(35, 45, 525, 190);
  doc.rect(225, 45, 335, 35, 'FD');
  doc.rect(225, 80, 335, 35, 'FD');
  doc.rect(225, 115, 168, 35, 'FD');
  doc.rect(393, 115, 167, 35, 'FD');
  doc.rect(225, 150, 335, 35, 'FD');

  doc.setTextColor("#7D7D7D")
  doc.setFontSize(8);
  doc.text(i18n.t('caseworker-pdfexport-text2'), 235, 55);
  doc.setTextColor("#000000")
  doc.setFontSize(14);
  doc.text(name ? name : "", 234, 72);

  doc.setTextColor("#7D7D7D")
  doc.setFontSize(8);
  doc.text(i18n.t("caseworker-pdfexport-text3"), 235, 90);
  doc.setTextColor("#000000")
  doc.setFontSize(14);
  doc.text(school ? school : "", 234, 107);

  doc.setTextColor("#7D7D7D")
  doc.setFontSize(8);
  doc.text(i18n.t("caseworker-pdfexport-text4"), 235, 125);
  doc.setTextColor("#000000")
  doc.setFontSize(14);
  doc.text(filterDate.from, 234, 142);

  doc.setTextColor("#7D7D7D")
  doc.setFontSize(8);
  doc.text(i18n.t("caseworker-pdfexport-text5"), 403, 125);
  doc.setTextColor("#000000")
  doc.setFontSize(14);
  doc.text(filterDate.to, 402, 142);

  doc.setTextColor("#7D7D7D")
  doc.setFontSize(8);
  doc.text(i18n.t(showPresence ? "caseworker-pdfexport-text6-attendance" : "caseworker-pdfexport-text6"), 235, 160);
  doc.setTextColor("#000000")
  doc.setFontSize(14);
  doc.text((totalAbsence ? (totalAbsence + "%") : "").replace('.', ','), 234, 177);


  //Registerings liste 
  doc.setDrawColor('#C5C5C5')
  doc.setFillColor(246, 246, 246);
  doc.rect(35, 260, 525, 24, 'FD');

  doc.setTextColor("#000000")
  doc.setFontSize(14);
  doc.text(i18n.t("caseworker-pdfexport-text7"), 45, 277);

  //loop boks for registrering list items
  doc.setTextColor("#000000")
  doc.setFontSize(12);

  doc.rect(35, 284, 80, 20);
  doc.text(i18n.t("caseworker-pdfexport-text8"), 75, 299, { align: 'center' });

  doc.rect(115, 284, 90, 20);
  doc.text(i18n.t("caseworker-pdfexport-text9"), 160, 299, { align: 'center' });

  doc.rect(205, 284, 100, 20);
  doc.text(i18n.t("class"), 215, 299);

  doc.rect(305, 284, 85, 20);
  doc.text(i18n.t("caseworker-pdfexport-text10"), 315, 299);

  doc.rect(390, 284, 100, 20);
  doc.text(i18n.t("caseworker-pdfexport-text11"), 400, 299);

  doc.rect(490, 284, 70, 20);
  doc.text(i18n.t("caseworker-pdfexport-text12"), 525, 299, { align: 'center' });

  doc.setFontSize(10);

  let tags = await db.getAllNote_Tags()
  tags.push({ tag_id: 99, name: "Late", html_color: 'FED425', picture: '', late: true })
  let startY = 304;
  let currentPageRow = 0;
  let pageCount = 1;

  for (let i = 0; i < registrations.length; i++) {
    if (currentPageRow * 20 + startY > 780) {
      startY = 89
      currentPageRow = 0;
      pageCount++;
      doc.addPage();
      doc.setTextColor("#000000")
      doc.setFontSize(10);
      doc.text(name ? name : "", 35, 30);
      doc.text(i18n.t('caseworker-pdfexport-text1') + " " + moment().format("DD-MM-YYYY"), 560, 30, { align: 'right' });

      //Registerings liste 
      doc.setDrawColor('#C5C5C5')
      doc.setFillColor(246, 246, 246);
      doc.rect(35, 45, 525, 24, 'FD');

      doc.setTextColor("#000000")
      doc.setFontSize(14);
      doc.text(i18n.t("caseworker-pdfexport-text7"), 45, 62);

      //loop boks for registrering list items
      doc.setTextColor("#000000")
      doc.setFontSize(12);

      doc.rect(35, 69, 80, 20);
      doc.text(i18n.t("caseworker-pdfexport-text8"), 75, 84, { align: 'center' });

      doc.rect(115, 69, 90, 20);
      doc.text(i18n.t("caseworker-pdfexport-text9"), 160, 84, { align: 'center' });

      doc.rect(205, 69, 100, 20);
      doc.text(i18n.t("class"), 215, 84);

      doc.rect(305, 69, 85, 20);
      doc.text(i18n.t("caseworker-pdfexport-text10"), 315, 84);

      doc.rect(390, 69, 100, 20);
      doc.text(i18n.t("caseworker-pdfexport-text11"), 400, 84);

      doc.rect(490, 69, 70, 20);
      doc.text(i18n.t("caseworker-pdfexport-text12"), 525, 84, { align: 'center' });


      doc.setFontSize(10);
    }
    let temp = registrations[i].lessondate.split('T')
    let startDateTime = temp[0] + " " + registrations[i].lessonstarttime.hours.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    }) + ":" + registrations[i].lessonstarttime.minutes.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })

    let endDateTime = temp[0] + " " + registrations[i].lessonsendtime.hours.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    }) + ":" + registrations[i].lessonsendtime.minutes.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
    let duration = moment(endDateTime).diff(startDateTime, 'minutes')
    let absenceDuration = registrations[i].duration / 60
    let absence = 0
    let cause = ""
    if (registrations[i].absencetype === 2) absence = duration
    else if (registrations[i].absencetype === 1 || registrations[i].absencetype === -1) absence = 0
    else if (registrations[i].absencetype === 3) absence = absenceDuration
    else absence = 15

    if (registrations[i].absencetype !== 1 && registrations[i].absencetype !== -1) {
      let ids = registrations[i].tag_ids ? registrations[i].tag_ids.split(',') : []
      ids.forEach(tagId => {
        let tag = tags.find(t => t.tag_id == tagId)
        if (cause !== "") cause += ","
        cause += i18n.t("tag-" + tag.name)
      });
    }

    doc.rect(35, startY + (currentPageRow * 20), 80, 20);
    doc.text(moment(registrations[i].lessondate).format("D MMM YYYY"), 75, startY + 14 + (currentPageRow * 20), { align: 'center' });

    doc.rect(115, startY + (currentPageRow * 20), 90, 20);
    let t = registrations[i].lessonstarttime.hours.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    }) + ":" + registrations[i].lessonstarttime.minutes.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    }) + " - " + registrations[i].lessonsendtime.hours.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    }) + ":" + registrations[i].lessonsendtime.minutes.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    })
    doc.text(t ? t : "", 160, startY + 14 + (currentPageRow * 20), { align: 'center' });
    doc.setFontSize(6);
    doc.rect(205, startY + (currentPageRow * 20), 185, 20);
    doc.text(registrations[i].course_Name ? registrations[i].course_Name : "-", 215, startY + 14 + (currentPageRow * 20));

    doc.rect(305, startY + (currentPageRow * 20), 185, 20);
    doc.text(registrations[i].course_Displayname ? registrations[i].course_Displayname : "-", 315, startY + 14 + (currentPageRow * 20));

    doc.rect(390, startY + (currentPageRow * 20), 100, 20);
    doc.text(cause !== "" && cause !== null && cause !== undefined ? cause : "-", 400, startY + 14 + (currentPageRow * 20));

    doc.setFontSize(10);
    doc.rect(490, startY + (currentPageRow * 20), 70, 20);
    doc.text(absence ? (absence + "m") : "0m", 525, startY + 14 + (currentPageRow * 20), { align: 'center' });
    currentPageRow++;
  }



  const addFooters = doc => {
    const pageCount = doc.internal.getNumberOfPages()
    doc.setFontSize(8)
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.text(`${i18n.t("caseworker-pdfexport-text13")} ${i} ${i18n.t("caseworker-pdfexport-text14")} ${pageCount}`, 298, 815, { align: 'center' });
    }
  }
  addFooters(doc)
  doc.save((name) + " " + (filterDate.from === null ? "01-01-2020" : moment(filterDate.from).format("DD-MM-YYYY")) + "_" + (filterDate.to === null ? moment().format("DD-MM-YYYY") : moment(filterDate.to).format("DD-MM-YYYY")) + ".pdf")

};